<template>
  <transition name="router-anim">
    <div class="kits">
      <!-- FBA Inventory Table -->
      <div class="form">
        <DescriptionModal class="description-modal" :description="'This page displays the available WS uploaded kit data, its status, and the order link on the WS site.'" />
        <div class="inv-data" >
          <h1>WS List</h1>
          <div class="inv-data-table">
            <SearchWs></SearchWs>
            <table v-if="!isEmpty" class="fba-table styled-table">
              <thead>
                <tr>
                <th class="position-sticky title-data">Order Number</th>
                <th class="position-sticky title-data">Woo Order Number</th>
                <th class="title-data">Customer Name</th>
                <th class="title-data">Variant Title</th>
                <th class="title-data">Status</th>
                <th class="title-data">Created Date</th>
                <th class="title-data">Updated Date</th>
                <th class="title-data">Order Link</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in tableData" :key="item.id">
                <td>{{ item.order_number }}</td>
                <td>{{ item.ws_order_number  }}</td>
                <td>{{ item.customer_name }}</td>
                <td>{{ item.variant_title }}</td> <!-- Fixed field name -->
                <td :class="statusClass(item.flag)">{{ getStatus(item.flag) }}</td>
                <td>{{ formatDate(item.created_at) }}</td>
                <td>{{ formatDate(item.updated_at) }}</td>
                <td>
                  <a v-if="item.ws_order_number != null" :href="generateWooOrderLink(item.ws_order_number)" target="_blank">
                    View Order
                  </a>
                </td>
              </tr>
            </tbody>
            </table>
            <div v-else class="kits-item">
              <div class="kit-desc nodata">
                No Data Retrieved.
              </div>
            </div>
          </div>
          <div class="pogination">
            <Paginate
              v-if="count_page > 1"
              :page-count="count_page"
              :page-class="'pogination-item'"
              :click-handler="changePage"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pogination-wrap'"
            ></Paginate>
          </div>
          <!-- Message for empty data -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import Paginate from "vuejs-paginate";
import SearchWs from "./search/SearchWs";

export default {
  name: 'WSList',
  components:{Paginate,SearchWs},
  data() {
  return {
    tableData: [],
    currentPage: 1,
    count_page: 0, // Total pages from backend
  };
},
  computed: {
    ...mapGetters('wckits', ['getWCkits']), // Get WCkits from Vuex store
    isEmpty() {
      return this.getWCkits.length === 0;
    }
  },
  watch:{
    getWCkits(newVal) {
       this.tableData = newVal;
    }
  },
  methods: {
    ...mapActions('wckits', ['fetchWCkits']), // Fetch kits when called
    // Generate WooCommerce order link dynamically
    generateWooOrderLink(orderNumber) {
      return `https://ws.gotmold.com/wp-admin/post.php?post=${orderNumber}&action=edit`;
    },
    // Convert flag to a readable status
    getStatus(flag) {
      if (flag == 0) return "Pending";
      if (flag == 1) return "Success";
      return "Failed";
    },

    // Add a class for styling based on the status
    statusClass(flag) {
      return {
        'text-warning': flag == 0, // Yellow for Pending
        'text-success': flag == 1, // Green for Success
        'text-danger': flag != 0 && flag != 1, // Red for Failed
      };
    },

    // Format the date using Moment.js
    formatDate(dateString) {
      return dateString ? moment(dateString).format('YYYY-MM-DD HH:mm:ss') : "N/A";
    },
    async loadOrders(page = 1) {
      try {
        const data = await this.fetchWCkits();
        this.tableData = data.data;
        this.count_page = data.last_page; // Total pages from backend
        this.currentPage = page;
      } catch (error) {
        console.error('Failed to load orders'+error);
      }
    },

    changePage(newPage) {
      this.loadOrders(newPage);
    }
  },
  mounted() {
     this.loadOrders();
  }
};
</script>

<style scoped>
.kits {
  margin: 50px 0;
}
.description-modal{
  text-align: start;
  position: absolute;
  top: 75px;
  left: 5px;
}
.form {
  padding-top: 20px;
}
.form, .sales-data {
  background-color: #fff;
  width: 100%;
  overflow-x: auto;
}
.form, .inv-data {
  background-color: #fff;
  width: 100%;

}
.inv-data-table {
  overflow-x: auto;
}

.editlog {
  padding-top: 20px;
}

.fba-table {
  width: 100%;
  border-collapse: unset;
}
.sales-table {
  width: 100%;
  border-collapse: collapse;
}

.fba-table th, .sales-table th, .fba-table td, .sales-table td {
  padding: 0 0 0 8px;
  text-align: left;
}

.fba-table th, .sales-table th {
  background-color: #005eb8;
  color: #f5f7fa;
  font-family: TTNormsMedium, sans-serif;
}

.filters {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.filters label {
  margin-right: 10px;
  font-family: TTNormsMedium, sans-serif;
  color: #b3b3b3;;;
}

.filters input {
  margin-right: 10px;
}

.filter-wrap-custom {
  display: flex;
  justify-content: flex-end;
  margin-left: 10px;
  width: 200px;
}
.filter-wrap-btn {
  display: inline-flex;
  justify-content: flex-end;
  margin-left: 10px;
}
.filter-list-wrap {
  position: absolute;
  right: 0px;
  top: 35px;
  width: 160px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 1px rgba(152, 164, 174, 0.4);
  z-index: 1;
}

.no-data-message {
  color: red;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}
 h1 {
  padding-bottom: 20px ;
  font-family: TTNormsBold, sans-serif;
  color: #1546ad;
  text-align: center;
  font-size: 20px;

 }

 h2 {
  padding-top: 7px ;
  font-family: TTNormsBold, sans-serif;
  color: #1546ad;
  text-align: center;
  font-size: 15px;
  padding-right: 25px;
 }

 .input-filter {
  padding: 5px 10px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  outline: none;
  border-radius: 5px;
  font-family: TTNormsRegular, sans-serif;
  background-color:#005eb8;
  color: #fff;
  border: 1px solid #005eb8;
  text-align-last: left;
}

.input-sub-filter {
  padding: 5px 10px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  outline: none;
  border-radius: 5px;
  font-family: TTNormsMedium, sans-serif;
  background-color:#fff;
  color: #005eb8;
  border: 1px solid #cccccc;
  text-align-last: left;
}

.input-sub-filter option {
  font-family: TTNormsLight, sans-serif;
  background-color: #fff;
  color: #373737;
  border: 1px solid #fff;
}

.input-filter option {
  font-family: TTNormsLight, sans-serif;
  background-color: #fff;
  color: #373737;
  border: 1px solid #fff;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 100px;
  width: 100%;
}

.btn {
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 5px 15px 5px 15px;
  cursor: pointer;
  border-radius: 5px;
}

.search-input {
  font-size: 14px;
  font-weight: 500px;
  font-family: TTNormsMedium, sans-serif;
  background-color: #fff;
  outline: none;
  border-radius: 10px;
  transition: all 0.5s linear;
  margin-right: 10px;
  margin-left: 10px;
  border: 1px solid #cccccc;
  height: 20px;
  padding-top: 14px;
  padding-bottom: 14px;
}
.search-input::placeholder {
  color: #cccccc;
  font-family: TTNormsMedium, sans-serif;
  opacity: 0.8;
}
.search-input:focus {
  background-color: #e3e3e3;
}
.text-right{
text-align: right !important;
padding-right: 5px !important;
}
.text-center{
  text-align: center !important;
}
.postion-sticky {
  position: sticky;
  left: 0;
  
  z-index: 1; /* Ensure sticky column stays on top */
  width: 150px; /* Fixed width for the sticky column */
}

.fba-table th:first-child{
  background-color: #005eb8;
  color: #fff;
  position: sticky;   /* Sticky column */
  left: 0;
  z-index: 1; 

}
.fba-table td:first-child {
  background-color: #fff;  /* Light background for the first column */
  position: sticky;   /* Sticky column */
  left: 0;
  z-index: 1;  /* Ensure the first column stays on top */
}
.fba-table tr:nth-child(even) td:first-child {
  background-color:  #f3f3f3;  /* Example color for alternate rows */
}

/* Style for the rest of the columns (both header and body cells) */

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.text-warning {
  color: orange;
}

.text-success {
  color: green;
}

.text-danger {
  color: red;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover > .kit-desc.date {
  min-width: 70px;
  width: 100%;
  max-width: 70px;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kits-item:hover .archive-kit-btn {
  display: block;
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
.kit-desc {
  color: #58595b;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
</style>
